import { StyleSheet } from 'react-native';
import { colors, sizes, defaultShadow } from '~/values';

const iconSize = 70;
const iconLastSize = 25;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    backgroundColor: 'white',
    ...defaultShadow,
    alignItems: 'flex-start',
    padding: sizes.horizontalSpacing,
    paddingTop: sizes.verticalSpaceSeparatorXL,
  },
  addressContainer: {
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    marginHorizontal: sizes.horizontalSpacing,
  },
  addressLineTitle: {
    color: colors.grayDark,
    fontSize: sizes.textNormal,
    textAlign: 'left',
  },
  addressLine1: {
    color: colors.grayDark,
    fontSize: sizes.textNormal,
    fontWeight: '600',
    textAlign: 'left',
  },
  addressLine2: {
    color: colors.grayDark,
    fontSize: sizes.textNormal,
    textAlign: 'left',
  },
  icon: {
    // tintColor: colors.primaryColor,
    borderRadius: 4,
    width: iconSize,
    height: iconSize,
    resizeMode: 'contain',
  },
  iconLast: {
    alignSelf: 'center',
    left: '100%',
    tintColor: colors.primaryColor,
    width: iconLastSize,
    height: iconLastSize,
    resizeMode: 'contain',
    position: 'absolute',
  },
});

export default styles;
